import type { HTMLAttributes } from 'react';

export function DetailSection(props: HTMLAttributes<HTMLDivElement>) {
  return <div className="flex flex-col gap-6 px-6" {...props} />;
}
